import React from "react";
import "./Home.css";
import { Link } from 'react-router-dom'
const Home = () => {
  return (
    <>
      <div id="main-home-container">
       
          <Link to='/Dresses'>
          <div id="home-1div-ad"> <img
            src="https://images.ctfassets.net/5de70he6op10/5tvZSI9QLr2rAOrAd2Rp98/4242fe2f9b542be485bd38f4330eae28/060922_G_EPromo_HPGSecondaryBanner_LS_01.jpg?w=2882&q=80&fm=webp"
            alt=""
          />
          </div></Link>
         
          <Link  to='/Dresses'>
            
        <div id="home-1div-ad2">
          
          <img
            src="https://images.ctfassets.net/5de70he6op10/6mrNlNQcyfQRVMyPxhUQxn/0706d907afba8421e6698bc8dc48591d/LS_M1.jpg?w=2694&q=80&fm=webp"
            alt=""
          />
        </div>

          </Link>

        <div id="home-1div-ad3">
          <div id="home-1div-ad3-child1">
          <Link  to='/Dresses'>
            <div id="home-1div-ad3-child1imgdiv1">
              <img
                src="https://images.ctfassets.net/5de70he6op10/6wEikTlTWzCZPWngawUcLV/992628b86552a9e040f58ebf5f560b42/LS_M2.jpg?w=1756&q=80&fm=webp"
                alt=""
              />
            </div>
            </Link>
            <Link  to='/Dresses'>
            <div id="home-1div-ad3-child1imgdiv2">
              <div id="home-1div-ad3-child1imgdiv2child">
                <img
                  style={{ width: "100%", height: "100%" }}
                  src="https://images.ctfassets.net/5de70he6op10/3rUi1Eeid1xe4HDiYaiTis/36bb9c78535ac35462e920885b18a443/2UP_Tops.jpg?w=856&q=80&fm=webp"
                  alt=""
                />
              </div>
              <div id="home-1div-ad3-child1imgdiv2child">
                <img
                  style={{ width: "100%", height: "100%" }}
                  src="https://images.ctfassets.net/5de70he6op10/7G5rHVwCD43wCKPMqRKZc6/a33a02e4def9ed38bbaef93b16289ec7/2UP_Pants.jpg?w=856&q=80&fm=webp"
                  alt=""
                />
              </div>
            </div>
            </Link>
            <Link  to='/Dresses'>
            <div id="home-1div-ad3-child1imgdiv3">
              <img
                style={{ width: "100%", height: "100%" }}
                src="https://images.ctfassets.net/5de70he6op10/7glZmCBO5aTLPPQg6DRWWx/a6b8a454dec9c02b23589a7bb89e23e9/LS_M4.jpg?w=1756&q=80&fm=webp"
                alt=""
              />
            </div>
            </Link>
          </div>
         

          <div id="home-1div-ad3-child2">
          <Link  to='/Dresses'>
            <div id="home-1div-ad3-child2imgdiv">
              <img
                src="https://images.ctfassets.net/5de70he6op10/66jTCus0kiqSj2n90w7kDd/7f1cf538272245b654046b8b332e95e7/RR_Shoes.jpg?w=856&q=80&fm=webp"
                alt=""
              />
            </div>
            </Link>
            <Link  to='/Dresses'>
            <div id="home-1div-ad3-child2imgdiv">
              <img
                src="https://images.ctfassets.net/5de70he6op10/6X3uggRIioCyxkk08z5oIW/d6f9a96965566f9017e8f21726e43998/RR_Dresses.jpg?w=856&q=80&fm=webp"
                alt=""
              />
            </div>
            </Link>
            <Link  to='/Dresses'>
            <div id="home-1div-ad3-child2imgdiv">
              <img
                src="https://images.ctfassets.net/5de70he6op10/4LUu4nPZntewZ7aM9PhSbh/9d13d728b77faf23caaf21fa1a18a495/RR_Candles.jpg?w=856&q=80&fm=webp"
                alt=""
              />
            </div>
            </Link>
            <Link  to='/Dresses'>
            <div id="home-1div-ad3-child2imgdiv">
              <img
                src="https://images.ctfassets.net/5de70he6op10/7KP7DrrSKqWzWqJ5vZf74F/655d513dd54420cbcbcc4c59e3cb7572/RR_Furniture.jpg?w=856&q=80&fm=webp"
                alt=""
              />
            </div>
             </Link>
           
          </div>
         
        </div>


        <div id="home-1div-ad51">
        <div id='home-1div-ad51p'><p>You May Also Like</p></div>
        <hr />
        <div id="home-1div-ad5">
          <div id="home-1div-ad5div">
            <img src="https://images.urbndata.com/is/image/Anthropologie/59379487_053_b2?$an-category$&qlt=80&fit=constrain" alt="" />
            <p>Capri Blue Volcano Multi-Surface Cleaner
</p>
          </div>
          <div id="home-1div-ad5div">
            <img src="https://images.urbndata.com/is/image/Anthropologie/64576390_040_b10?$an-category$&qlt=80&fit=constrain" alt="" />
            <p>August Wren Dinner Plate
</p>
          </div>
          <div id="home-1div-ad5div">
            <img src="https://images.urbndata.com/is/image/Anthropologie/66524406_060_b2?$an-category$&qlt=80&fit=constrain" alt="" />
            <p>Anemone Watercolor Floral Wallpaper
</p>
          </div>
          <div id="home-1div-ad5div">
            <img src="https://images.urbndata.com/is/image/Anthropologie/60467438_040_b?$an-category$&qlt=80&fit=constrain" alt="" />
            <p>Briar Tumbler
</p>
          </div>
          <div id="home-1div-ad5div">
            <img src="https://images.urbndata.com/is/image/Anthropologie/4112916210052_070_b2?$an-category$&qlt=80&fit=constrain" alt="" />
            <p>
Briar Pasta Bowl
</p>
          </div>

        </div>



        </div>













        <div id="home-1div-ad4">
          <div id="explore">
            <p>More to Explore</p>
          </div>
          <hr />
          <div id="home-1div-ad4child">
            <div id="home-1div-ad4child1">
              <img
                src="https://images.ctfassets.net/5de70he6op10/4lWXFXOjiia6HPkbeCNQGK/018f30ecc52f0b6cf3cccc62cb3866c7/MTE_Getaway.jpg?w=856&q=80&fm=webp"
                alt=""
              />

              <div>
                <h2 className="little">Just Coasting</h2>
              </div>
              <div className="h4div">
                <h4>
                  When the dress code's breezy and the living's easy, it's
                  official: SUMMER is finally here.
                </h4>
              </div>
              <div className="atag">
                <a href="">visit the getaway shop</a>
              </div>
            </div>

            <div id="home-1div-ad4child1">
              <img
                src="https://images.ctfassets.net/5de70he6op10/5z1SzJjtkNuitP2HKuc7Ww/4f0f76621a8587e50d4b9e96a30edf36/041122_HPG_MTE_GreaterGood.jpg?w=856&q=80&fm=webp"
                alt=""
              />
              <div>
                <h2 className="little">
                  <u>A</u> Greater Good
                </h2>
              </div>
              <div className="h4div">
                <h4>
                  Our priority: to be a force for good, a greater good, in
                  better service of our planet, its people, and our products.
                </h4>
              </div>
              <div className="atag">
                <a href="">learn more about our journey</a>
              </div>
            </div>
            <div id="home-1div-ad4child1">
              <img
                src="https://images.ctfassets.net/5de70he6op10/49rdsFgsKhGoiPP98cJnl4/710954132da29d2dbd33de49eeabe5b0/MTE_MarkDSikes.jpg?w=856&q=80&fm=webp"
                alt=""
              />

              <div>
                <h2 className="little">
                  Mark D. Sikes: Exclusively at Anthropologie
                </h2>
              </div>
              <div className="h4div">
                <h4>
                  Arrange your table with fresh takes on timeless essentials,
                  set in the esteemed designer's signature color palette.
                </h4>
              </div>
              <div className="atag">
                <a href="">shop the Poppy collection</a>
              </div>
            </div>
          </div>
          <hr />
          <div className='about'>
                <div>
                    <h2>About Us</h2>
                    <h4>Our mission at Anthropologie has always been to surprise and delight you with unexpected, distinctive finds for your closet and home. We source and craft all of our products with care, ensuring that any treasure you find at Anthropologie is unique, just like you. Explore our dress shop to find styles and fits perfect for any occasi...</h4>
                </div>
                <p className='atag'><a href=''>Read More</a></p>
            </div>
        </div>
      </div>
    </>
  );
};

export default Home;
